export const updateCartHeader = () => {
  document.dispatchEvent(new CustomEvent('header:cart:overview:update'));
};

export const updateWishlistHeader = () => {
  document.dispatchEvent(new CustomEvent('header:wishlist:overview:update'));
};
